import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PushPinIcon(props: IconProps) {
    return <Icon {...props} iconKey={"push_pin"}/>
}
